var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cloud",style:(_vm.opacityIntensivity)},[_c('img',{attrs:{"src":_vm.cloudImage,"alt":"Cloud"}})])}
var staticRenderFns = []

export { render, staticRenderFns }